__turbopack_context__.v({
  "arrowBtn": "restaurant-module__AEHNwa__arrowBtn",
  "audioAgentName": "restaurant-module__AEHNwa__audioAgentName",
  "audioAgentStatus": "restaurant-module__AEHNwa__audioAgentStatus",
  "audioAvatar": "restaurant-module__AEHNwa__audioAvatar",
  "audioLabel": "restaurant-module__AEHNwa__audioLabel",
  "audioPlayBtn": "restaurant-module__AEHNwa__audioPlayBtn",
  "audioPlayIcon": "restaurant-module__AEHNwa__audioPlayIcon",
  "audioStatusDot": "restaurant-module__AEHNwa__audioStatusDot",
  "audioStatusDotActive": "restaurant-module__AEHNwa__audioStatusDotActive",
  "audioWaveBar": "restaurant-module__AEHNwa__audioWaveBar",
  "audioWaveBarActive": "restaurant-module__AEHNwa__audioWaveBarActive",
  "audioWaveform": "restaurant-module__AEHNwa__audioWaveform",
  "audioWidget": "restaurant-module__AEHNwa__audioWidget",
  "audioWidgetHeader": "restaurant-module__AEHNwa__audioWidgetHeader",
  "ctaBtn": "restaurant-module__AEHNwa__ctaBtn",
  "ctaImage": "restaurant-module__AEHNwa__ctaImage",
  "ctaInner": "restaurant-module__AEHNwa__ctaInner",
  "ctaOverlay": "restaurant-module__AEHNwa__ctaOverlay",
  "ctaSection": "restaurant-module__AEHNwa__ctaSection",
  "ctaSubtitle": "restaurant-module__AEHNwa__ctaSubtitle",
  "ctaTitle": "restaurant-module__AEHNwa__ctaTitle",
  "fcIllusArea": "restaurant-module__AEHNwa__fcIllusArea",
  "fcPulse": "restaurant-module__AEHNwa__fcPulse",
  "fcSubtitle": "restaurant-module__AEHNwa__fcSubtitle",
  "fcTextArea": "restaurant-module__AEHNwa__fcTextArea",
  "fcTitle": "restaurant-module__AEHNwa__fcTitle",
  "fcWave": "restaurant-module__AEHNwa__fcWave",
  "featureCard": "restaurant-module__AEHNwa__featureCard",
  "featuresGrid": "restaurant-module__AEHNwa__featuresGrid",
  "featuresInner": "restaurant-module__AEHNwa__featuresInner",
  "featuresSection": "restaurant-module__AEHNwa__featuresSection",
  "hero": "restaurant-module__AEHNwa__hero",
  "heroBtnPrimary": "restaurant-module__AEHNwa__heroBtnPrimary",
  "heroBtnSecondary": "restaurant-module__AEHNwa__heroBtnSecondary",
  "heroBtns": "restaurant-module__AEHNwa__heroBtns",
  "heroContent": "restaurant-module__AEHNwa__heroContent",
  "heroImage": "restaurant-module__AEHNwa__heroImage",
  "heroLayout": "restaurant-module__AEHNwa__heroLayout",
  "heroOverlay": "restaurant-module__AEHNwa__heroOverlay",
  "heroSubtitle": "restaurant-module__AEHNwa__heroSubtitle",
  "heroTag": "restaurant-module__AEHNwa__heroTag",
  "heroTitle": "restaurant-module__AEHNwa__heroTitle",
  "howItWorksHeader": "restaurant-module__AEHNwa__howItWorksHeader",
  "howItWorksSection": "restaurant-module__AEHNwa__howItWorksSection",
  "howSubtitle": "restaurant-module__AEHNwa__howSubtitle",
  "howTitle": "restaurant-module__AEHNwa__howTitle",
  "howTitleItalic": "restaurant-module__AEHNwa__howTitleItalic",
  "illusAgent": "restaurant-module__AEHNwa__illusAgent",
  "illusCallBadge": "restaurant-module__AEHNwa__illusCallBadge",
  "illusCallDot": "restaurant-module__AEHNwa__illusCallDot",
  "illusCallNumber": "restaurant-module__AEHNwa__illusCallNumber",
  "illusCallWrap": "restaurant-module__AEHNwa__illusCallWrap",
  "illusDoc": "restaurant-module__AEHNwa__illusDoc",
  "illusDocBack1": "restaurant-module__AEHNwa__illusDocBack1",
  "illusDocBack2": "restaurant-module__AEHNwa__illusDocBack2",
  "illusDocFront": "restaurant-module__AEHNwa__illusDocFront",
  "illusDocIcon": "restaurant-module__AEHNwa__illusDocIcon",
  "illusEventBadge": "restaurant-module__AEHNwa__illusEventBadge",
  "illusEventCard": "restaurant-module__AEHNwa__illusEventCard",
  "illusEventRow": "restaurant-module__AEHNwa__illusEventRow",
  "illusEventTitle": "restaurant-module__AEHNwa__illusEventTitle",
  "illusLangBubble": "restaurant-module__AEHNwa__illusLangBubble",
  "illusLangTag": "restaurant-module__AEHNwa__illusLangTag",
  "illusLangText": "restaurant-module__AEHNwa__illusLangText",
  "illusLangWrap": "restaurant-module__AEHNwa__illusLangWrap",
  "illusLive": "restaurant-module__AEHNwa__illusLive",
  "illusLiveBadge": "restaurant-module__AEHNwa__illusLiveBadge",
  "illusLiveDot": "restaurant-module__AEHNwa__illusLiveDot",
  "illusLiveList": "restaurant-module__AEHNwa__illusLiveList",
  "illusOrderRow": "restaurant-module__AEHNwa__illusOrderRow",
  "illusOrderSlip": "restaurant-module__AEHNwa__illusOrderSlip",
  "illusOrderTitle": "restaurant-module__AEHNwa__illusOrderTitle",
  "illusOrderTotal": "restaurant-module__AEHNwa__illusOrderTotal",
  "illusPanel": "restaurant-module__AEHNwa__illusPanel",
  "illusPanelLabel": "restaurant-module__AEHNwa__illusPanelLabel",
  "illusPanelOn": "restaurant-module__AEHNwa__illusPanelOn",
  "illusPanelRow": "restaurant-module__AEHNwa__illusPanelRow",
  "illusPanelValue": "restaurant-module__AEHNwa__illusPanelValue",
  "illusPhone": "restaurant-module__AEHNwa__illusPhone",
  "illusPhoneBadge": "restaurant-module__AEHNwa__illusPhoneBadge",
  "illusPhoneLabel": "restaurant-module__AEHNwa__illusPhoneLabel",
  "illusPhoneNum": "restaurant-module__AEHNwa__illusPhoneNum",
  "illusReservCard": "restaurant-module__AEHNwa__illusReservCard",
  "illusReservConfirm": "restaurant-module__AEHNwa__illusReservConfirm",
  "illusReservRow": "restaurant-module__AEHNwa__illusReservRow",
  "illusReservTitle": "restaurant-module__AEHNwa__illusReservTitle",
  "illusStack": "restaurant-module__AEHNwa__illusStack",
  "illusStatusBadge": "restaurant-module__AEHNwa__illusStatusBadge",
  "illusStatusEst": "restaurant-module__AEHNwa__illusStatusEst",
  "illusStatusMsg": "restaurant-module__AEHNwa__illusStatusMsg",
  "illusStatusWrap": "restaurant-module__AEHNwa__illusStatusWrap",
  "illusWaveBar": "restaurant-module__AEHNwa__illusWaveBar",
  "illusWaveBars": "restaurant-module__AEHNwa__illusWaveBars",
  "livePulse": "restaurant-module__AEHNwa__livePulse",
  "page": "restaurant-module__AEHNwa__page",
  "sectionHeader": "restaurant-module__AEHNwa__sectionHeader",
  "sectionLabel": "restaurant-module__AEHNwa__sectionLabel",
  "slideCard": "restaurant-module__AEHNwa__slideCard",
  "slideCard1": "restaurant-module__AEHNwa__slideCard1",
  "slideCard2": "restaurant-module__AEHNwa__slideCard2",
  "slideCard3": "restaurant-module__AEHNwa__slideCard3",
  "slideCard4": "restaurant-module__AEHNwa__slideCard4",
  "slideDesc": "restaurant-module__AEHNwa__slideDesc",
  "slideIllus": "restaurant-module__AEHNwa__slideIllus",
  "slideNum": "restaurant-module__AEHNwa__slideNum",
  "slideText": "restaurant-module__AEHNwa__slideText",
  "slideTitle": "restaurant-module__AEHNwa__slideTitle",
  "sliderArrows": "restaurant-module__AEHNwa__sliderArrows",
  "sliderViewport": "restaurant-module__AEHNwa__sliderViewport",
});
